import { useEffect, useRef, useState } from 'react';
import { useAsync } from 'react-use';
import { Col, Form, Grid, Image, Popover, Row, Select, Typography } from 'antd';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import CardC from 'src/components/Card';
import { ButtonOK } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import CalendarResult from 'src/components/KalenderKehamilan/CalendarResult';
import DatePickerKalkulator from 'src/components/KalenderKehamilan/DatePicker';
import Disclaimer from 'src/components/KalenderKehamilan/Disclaimer';
import KehamilanResult from 'src/components/KalenderKehamilan/KehamilanResult/KehamilanResult';
import { RESULT_CHECK_HEALTHTOOLS } from 'src/constants/localStorage';
import { useCalculateFertility } from 'src/hooks/useCalculateFertility';
import { changeFormatDate } from 'src/utils/func/kalender-kehamilan';
import style from './style.module.less';
const QuestionKalenderKehamilan = (props: any) => {
  const {
    router
  } = props;
  const {
    xs
  } = Grid.useBreakpoint();
  const [form] = Form.useForm();
  const [disableBtn, setDisabledBtn] = useState(true);
  const [disableBtn2, setDisabledBtn2] = useState(true);
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState('Menstrual');
  const [showReusult, setShowResult] = useState(false);
  const [listDay, setListDay] = useState<any>();
  const myRef = useRef<any>(null);
  const onResetForm = () => {
    if (router?.query?.uid) {
      router.push('/kalender-kehamilan/cek');
    }
    setShowResult(false);
    setDisable(false);
    form.setFieldsValue({
      longTime: 7,
      menstrual: 28
    });
    localStorage.removeItem(RESULT_CHECK_HEALTHTOOLS);
  };
  useAsync(async () => {
    try {
      const Url = `${process.env.NEXT_PUBLIC_PARTNER}/sign`;
      const data = {
        grant_type: `${process.env.NEXT_PUBLIC_GT_GRANT_TYPE}`,
        client_id: `${process.env.NEXT_PUBLIC_GT_CLIENT_ID}`,
        client_secret: `${process.env.NEXT_PUBLIC_GT_CLIENT_SECRET}`
      };
      const urlEncodedData = new URLSearchParams(data).toString();
      const opt = {
        method: 'POST',
        headers: {
          Accept: 'application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: urlEncodedData
      };
      const signfeedback = await fetch(Url, opt);
      const dataNew = await signfeedback.json();
      dataNew.status = signfeedback.status;
      if (dataNew.status === 200) {
        Cookies.set('Token', JSON.stringify(dataNew.access_token), {
          expires: 1
        });
      }
    } catch (error) {}
  }, []);
  const {
    mutate: updateData,
    isPending
  } = useCalculateFertility({
    onSuccess: async (response: any) => {
      const formValues = form.getFieldsValue();
      setShowResult(true);
      setListDay(response.data.record);
      localStorage.setItem(RESULT_CHECK_HEALTHTOOLS, JSON.stringify({
        ...response?.data?.record,
        hpht: dayjs(formValues.calendar).format('DD/MM/YYYY'),
        menstrual_cycle: parseInt(formValues.menstrual),
        menstrual_period: parseInt(formValues.longTime)
      }));
    },
    onError: (error: any) => {
      console.log('❌ onError:', error); // tambah ini
    }
  });
  const [siklus, setSiklus] = useState('');
  const handleChange = (value: string) => {
    setSiklus(value);
    setDisabledBtn(false);
  };
  const [longTime, setLongTime] = useState('');
  const handleChangeLT = (value: string) => {
    setLongTime(value);
    setDisabledBtn2(false);
  };
  const onFinish = async (values: any) => {
    const formValues = form.getFieldsValue();
    if (values) {
      const payload = {
        // check_type: type,
        start_date: dayjs(formValues.calendar).format('YYYY-MM-DD'),
        mens_cycle: parseInt(siklus),
        mens_duration: parseInt(longTime)
      };
      updateData(payload);
    }
  };
  useEffect(() => {
    if (!form.getFieldValue('longTime')) {
      form.setFieldsValue({
        longTime: 7,
        menstrual: 28
      });
    }
  }, []);
  useEffect(() => {
    if (myRef.current) {
      setTimeout(() => {
        myRef?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 500);
    }
  }, [showReusult]);
  useEffect(() => {
    const resultLocalStorage = JSON.parse(localStorage.getItem(RESULT_CHECK_HEALTHTOOLS) as any);
    if (resultLocalStorage && resultLocalStorage.check_type) {
      updateData({
        // check_type: resultLocalStorage.check_type as string,
        start_date: resultLocalStorage.hpht as string,
        mens_cycle: parseInt(resultLocalStorage.menstrual_cycle as string),
        mens_duration: parseInt(resultLocalStorage.menstrual_period as string)
      });
      setType(resultLocalStorage.check_type as string);
      form.setFieldsValue({
        calendar: dayjs(changeFormatDate(resultLocalStorage.hpht as string)),
        longTime: parseInt(resultLocalStorage.menstrual_period as string),
        menstrual: parseInt(resultLocalStorage.menstrual_cycle as string)
      });
    }
  }, []);
  const renderResult = () => {
    return <div ref={myRef}>
				{type === 'Menstrual' ? <CalendarResult router={router} defaultValue={router?.query?.hpht} listDay={listDay} onRetest={() => onResetForm()} /> : <KehamilanResult router={router} listDay={listDay} onRetest={() => onResetForm()} />}
			</div>;
  };
  const content1 = <div>
			<Typography className={style.paragraph}>
				Isi dengan tanggal pertama Mama mulai haid terakhir, ya!
			</Typography>
		</div>;
  const content2 = <div>
			<Typography className={style.paragraph}>
				Isi dengan total hari biasanya Mama haid.
				<span>
					<br />
				</span>
				Terhitung dari hari pertama haid sampai hari terakhir, ya!
			</Typography>
		</div>;
  const content3 = <div>
			<Typography className={style.paragraph}>
				Isi dengan total hari dari hari pertama
				<span>
					<br />
				</span>{' '}
				haid terakhir sampai sehari sebelum haid berikutnya.
				<span>
					<br />
				</span>
				Biasanya sekitar 21-35 hari, tapi tiap orang beda-beda!
			</Typography>
		</div>;
  useEffect(() => {
    window.scrollBy({
      top: 5,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return <div className={style.question}>
			<div className={style.inputForm}>
				<div>
					<div className="d-flex justify-content-center">
						<CardC>
							<h1 className={style.title}>Perhitungan Masa Subur</h1>
							<div className={style.images}>
								<Image src="/images/kalender-kesuburan/kesuburan.svg" alt="image" preview={false} />
							</div>
							<div className={style.form}>
								<Form form={form} validateTrigger="onBlur" layout="vertical" onFinish={onFinish} autoComplete="off" name="ant-info-custom">
									<Row>
										<Col span={21}>
											<Form.Item className="position-relative" label={<h2 style={{
                      color: '#4A5454',
                      fontWeight: '400',
                      fontSize: '14px'
                    }}>
														Kapan menstruasi terakhir Mama dimulai?
													</h2>} style={{
                      marginBottom: '-60px'
                    }}>
												<DatePickerKalkulator name="calendar" className={style.inputCalendar} />
											</Form.Item>
										</Col>
										<Col span={3}>
											<Form.Item
                    // className="position-relative"
                    label="  " className={style.informasilabel}>
												<Popover content={content1} trigger="click" placement="bottomRight">
													<IconCustom iconName="kkInfo" />
												</Popover>
											</Form.Item>
										</Col>
										<Col span={21}>
											<Form.Item className="position-relative" label={<h2 style={{
                      color: '#4A5454',
                      fontWeight: '400',
                      fontSize: '14px',
                      marginTop: xs ? '20px' : '0px'
                    }}>
														Berapa total durasi haid Mama?
													</h2>} rules={[{
                      required: true,
                      message: 'Berapa lama menstruasi kamu diperlukan'
                    }]}>
												<Select style={{
                        border: '1px solid #ced4da',
                        paddingLeft: '20px',
                        padding: '5px',
                        borderRadius: '12px'
                      }} onChange={handleChangeLT} options={[{
                        value: '2',
                        label: '2 Hari'
                      }, {
                        value: '3',
                        label: '3 Hari'
                      }, {
                        value: '4',
                        label: '4 Hari'
                      }, {
                        value: '5',
                        label: '5 Hari'
                      }, {
                        value: '6',
                        label: '6 Hari'
                      }, {
                        value: '7',
                        label: '7 Hari'
                      }]} placeholder="Pilih total durasi haid Mama" />
											</Form.Item>
										</Col>
										<Col span={3}>
											<Form.Item
                    // className="position-relative"
                    label="  " className={style.informasilabel1}>
												<Popover content={content2} trigger="click" placement="bottomRight">
													<IconCustom iconName="kkInfo" />
												</Popover>
											</Form.Item>
										</Col>
										<Col span={21}>
											<Form.Item className="position-relative" label={<h2 style={{
                      color: '#4A5454',
                      fontWeight: '400',
                      fontSize: '14px'
                    }}>
														Berapa total hari siklus Mama?
													</h2>} rules={[{
                      required: true,
                      message: 'Berapa hari siklus menstruasi Mama diperlukan'
                    }]}>
												<Select style={{
                        border: '1px solid #ced4da',
                        paddingLeft: '20px',
                        padding: '5px',
                        borderRadius: '12px'
                      }} onChange={handleChange} options={[{
                        value: '21',
                        label: '21 Hari'
                      }, {
                        value: '22',
                        label: '22 Hari'
                      }, {
                        value: '23',
                        label: '23 Hari'
                      }, {
                        value: '24',
                        label: '24 Hari'
                      }, {
                        value: '25',
                        label: '25 Hari'
                      }, {
                        value: '26',
                        label: '26 Hari'
                      }, {
                        value: '27',
                        label: '27 Hari'
                      }, {
                        value: '28',
                        label: '28 Hari'
                      }, {
                        value: '29',
                        label: '29 Hari'
                      }, {
                        value: '30',
                        label: '30 Hari'
                      }, {
                        value: '31',
                        label: '31 Hari'
                      }, {
                        value: '32',
                        label: '32 Hari'
                      }, {
                        value: '33',
                        label: '33 Hari'
                      }, {
                        value: '34',
                        label: '34 Hari'
                      }, {
                        value: '35',
                        label: '35 Hari'
                      }]} placeholder="Pilih total hari siklus Mama" />
											</Form.Item>
										</Col>
										<Col span={3}>
											<Form.Item
                    // className="position-relative"
                    label="  " className={style.informasilabel1}>
												<Popover content={content3} trigger="click" placement="bottomRight">
													<IconCustom iconName="kkInfo" />
												</Popover>
											</Form.Item>
										</Col>
										<Col className="d-flex justify-content-center" span={24}>
											<Form.Item>
												<ButtonOK className={style.buttonSubmit} block htmlType="submit" text={'Hitung'} disabled={disable || disableBtn || disableBtn2} loading={isPending} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
							</div>
						</CardC>
					</div>
					{showReusult ? <div className="d-flex justify-content-center">
							<Disclaimer></Disclaimer>
						</div> : ''}
					{showReusult ? <div className="d-flex justify-content-center">{renderResult()}</div> : ''}
				</div>
			</div>
		</div>;
};
export default QuestionKalenderKehamilan;